import type { DataTableHeader } from '@/types/vuetify';

export function createAuditPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            maxWidth: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('audit.time'),
            value: 'created_at',
            key: 'created_at',
            align: 'start',
            sortable: true,
            nowrap: true,
            width: 158,
            maxWidth: 158,
        },
        {
            title: t('audit.action'),
            value: 'actionId',
            key: 'action_id',
            align: 'start',
            sortable: false,
            nowrap: true,
            width: 88,
            maxWidth: 88,
        },
        {
            title: t('audit.name'),
            value: 'editedRecordName',
            key: 'edited_record_name',
            align: 'start',
            sortable: false,
            nowrap: true,
            width: 160,
            maxWidth: 160,
            headerProps: { class: 'nowrap' },
            cellProps: { class: 'audit-col-truncate' },
        },
        {
            title: t('audit.editedFields'),
            value: 'collapsedEditedFieldsPlain',
            key: 'edited_field',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap audit-col-edited-field' },
            cellProps: { class: 'audit-col-truncate audit-col-edited-field' },
        },
        {
            title: t('audit.user'),
            value: 'author',
            key: 'author',
            align: 'start',
            sortable: false,
            nowrap: true,
            width: 120,
            maxWidth: 120,
            headerProps: { class: 'nowrap' },
            cellProps: { class: 'audit-col-truncate' },
        },
        {
            title: '',
            value: 'actionsMenu',
            key: 'actionsMenu',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 72,
            maxWidth: 72,
            headerProps: { class: 'px-0' },
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
